<template>
  <f-dashboard-content-layout>
    <template #dashboard-content-side>
      <f-dashboard-content-nav
        :links="partnerLinks"
      >
        <template #title>
          <f-box
            class="user-nav-card"
          >
            <f-badge 
              :image="logo"
              :placeholder="username"
              class="user-nav-item"
              size="large"
            ></f-badge>

            <h6 class="user-nav-item">
              <small>{{ username }}</small>
            </h6>
          </f-box>
        </template>
      </f-dashboard-content-nav>
    </template>

    <router-view></router-view>
  </f-dashboard-content-layout>
</template>

<script>
import { computed, ref, reactive, watch, toRefs, nextTick } from 'vue'
import { useStore } from '@freebe/sdk/store'
import useLogo from '@composables/admins/use-logo'
import router from '@core/router'
 
export default {
  async setup () {
    const { me: user } = useStore('@admin/users')
    const { find: findPartners, fetch: fetchPartners } = useStore('@admin/partners')
    const { get: getStats, fetch: fetchStats } = useStore('@admin/partners/stats')
    const { logo } = useLogo(user.value._id)
    
    const partnerIds = user.value.partner_ids

    await fetchPartners({
      query: {
        _id: { $in: partnerIds }
      }
    })
    
    await fetchStats({
      query: {
        partner_ids: partnerIds,
      }
    })

    if (!router.currentRoute.value.params.partner_id) {
      router.replace({
        name: 'growth-cashback',
        params: {
          partner_id: partnerIds[0],
        }
      })
    }

    const state = reactive({
      username: user.value.firstname + ' ' + user.value.lastname,

      partnerId: computed(() => router.currentRoute.value.params.partner_id),

      currentStat: computed(() => getStats(state.partnerId)),
      totalCashback: computed(() => state.currentStat?.cashback || 0),
      totalSignups: computed(() => state.currentStat?.signup || 0),
      totalSubscriptions: computed(() => state.currentStat?.subscriptions || 0),

      partners: computed(() => findPartners()),

      partnerLinks: computed(() => {
        return state.partners.map(partner => {
          return {
            name: partner.name,
            to: { 
              name: 'growth-cashback',
              params: {
                partner_id: partner._id,
              }
            }
          }
        })
      }),
    })

    return {
      logo,
      ...toRefs(state),
    }
  },
}
</script>

<style lang="scss">
  .user-nav-card {
    padding: 0.45rem 1rem 0.45rem 1rem;
    // height: 180px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .user-nav-item {
    margin: 1rem;
  }
</style>
